<template>
  <div class="share-qr-code" v-if="code && visible">
    <div class="share-qr-code-img">
      <img :src="shareCodePng" alt="请扫码" style="width: 100%; height: 100%" />
      <img :src="code" alt="请扫码" class="share-qr-code-img-code" />
      <div class="close-btn" @click="handleClose">×</div>
    </div>
  </div>
</template>

<script>
import shareCodePng from "@/config/assets/images/shareCode.png";
export default {
  name: "shareQRCode",
  props: {
    code: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      shareCodePng,
      visible: true,
    };
  },
  methods: {
    handleClose() {
      this.visible = false;
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.share-qr-code {
  width: 180px;
  height: 250px;
  margin: 0 auto;
  position: fixed;
  bottom: 100px;
  right: 5px;
  z-index: 1000;

  .share-qr-code-img {
    width: 100%;
    height: 100%;
    position: relative;

    .share-qr-code-img-code {
      width: 130px !important;
      height: 130px !important;
      position: absolute;
      top: 100px;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      height: 100%;
    }

    .close-btn {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 20px;
      height: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
</style>
